import DateTimeFilter from "app/Components/CommanComponents/DateTimeFilter";
import DatePicker from "app/Components/DateTimeCustom/DateRangePickerCustom";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import { getAllSites, getAllSitesWithAccess } from "app/_services/ehs/ehsSiteServices";
import ScrollBar from "react-perfect-scrollbar";
import { IS_USER_SITE_MINES } from "../_healthSafetyEnvironment/IncidentManagement/Helper";
import { useSelector } from "react-redux";

const initailForm = {
  ROsites: [{ mineSites: [{}] }],
};

const RightFilter = ({ applyFilter }) => {
  //Toggle filter
  const [isActive, setActive] = useState(false);
  const [isActive2, setActive2] = useState(false);
  const handleToggle = () => {
    setActive(!isActive);
    setActive2((isActive2 && false) || false);
  };
  const handleToggle2 = () => {
    setActive2(!isActive2);
    setActive((isActive && false) || false);
  };
  const globalSelectedSiteId = useSelector((state) => state.userData?.siteIds);
  const subHandleToggle = (index) => {
    const checkToggle = filter?.ROsitesData.map((prev, idx) => ({
      ...prev,
      isToggle: index === idx ? !prev?.isToggle : (prev?.isToggle && false) || false,
    }));
    setFilter((prev, idx) => ({
      ...prev,
      ROsitesData: checkToggle,
    }));
  };
  // End
  const [sites, setSites] = useState([]);
  const [sitesAccess, setSitesAccess] = useState([]);
  const [filter, setFilter] = useState({ siteId: [] });
  const [filterSearch, setFilterSearch] = useState("");
  const [form, setForm] = useState({ ...initailForm });
  const [clearDate, setClearDate] = useState(false);

  useEffect(() => {
    getAllSitesWithAccess().then((response) => {
      if (!response?.data) return;
      setSites(response?.data?.availableSites || []);

      if (globalSelectedSiteId) {
        const getSiteData = response?.data?.availableSites.find(
          (d) => d.id == globalSelectedSiteId
        );
        const haveAccessToSite = !getSiteData
          ? []
          : getSiteData.siteType == 1
          ? response?.data?.availableSites.map((d) => {
              return d.id;
            })
          : getSiteData.siteType == 2
          ? response?.data?.availableSites
              .filter((d) => {
                if (
                  d.id == globalSelectedSiteId ||
                  d.parentSiteId == globalSelectedSiteId
                )
                  return d.id;
              })
              .map((d) => {
                return d.id;
              })
          : getSiteData.siteType == 3
          ? response?.data?.availableSites
              .filter((d) => {
                if (d.id == globalSelectedSiteId) return d.id;
              })
              .map((d) => {
                return d.id;
              })
          : [];
        // console.log("/*/*/*/*/*/**/availableSites", haveAccessToSite);

        setSitesAccess(haveAccessToSite || []);
      } else {
        setSitesAccess(response?.data?.haveAccessToSites || []);
      }
    });
  }, [globalSelectedSiteId]);

  const onSearchFun = ({ target: { name, type, value } }) => {
    type != "checkbox" && setFilterSearch(value.toLowerCase());
  };

  const onChange = ({ target: { id, name, type, checked, value } }) => {
    if (clearDate) setClearDate(false);
    let mineIds = [];
    if (name === "ROFilter") {
      let mineDataByRo = form?.ROsites?.find((d) => d.id === +id)?.mineSites || [];
      mineIds = mineDataByRo?.map((d) => d?.id);
    }

    id = +id;

    setFilter((prev) => {
      let filterMine = prev.siteId.filter((value) => !mineIds.includes(+value));
      prev.siteId = filterMine;
      return {
        ...prev,
        // [name]: checked
        //   ? [...filter?.[name], value]
        //   : filter?.[name].filter((d) => d !== value),
        siteId:
          checked && !prev.siteId.includes(id)
            ? [...prev.siteId, ...mineIds, id]
            : prev.siteId.filter((d) => d !== id),
      };
    });
  };

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      ROsites: sites
        .filter((item) => item?.siteType == 2)
        .map((d) => ({
          ...d,
          mineSites: sites.filter(
            (item) => item?.siteType == 3 && item?.parentSite?.id == d?.id
          ),
        })),
    }));
  }, [sites]);

  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      ROsitesData: form?.ROsites?.filter(
        (item) =>
          item?.name?.toLowerCase().includes(filterSearch || "") ||
          item?.mineSites?.filter((item) =>
            item?.name?.toLowerCase().includes(filterSearch || "")
          ).length > 0
      ).map((item) => ({
        ...item,
        isToggle: false,
        mineSites: item?.mineSites?.filter((item) =>
          item?.name?.toLowerCase().includes(filterSearch || "")
        ),
      })),

      // ROFilter: [],
      // MineFilter: [],
    }));
  }, [filterSearch, form]);

  const getDate = (first, last, date = null, prevDate) => {
    if (clearDate) setClearDate(false);

    setFilter((prev) => ({
      ...prev,
      startDate: first,
      endDate: last,
    }));

    // this.setState({
    //   prevDate: prevDate,
    // });
    // this.dashboardData(first, last);
  };

  const onClickApply = () => {
    applyFilter({
      startDate: filter?.startDate,
      endDate: filter?.endDate,
      siteId: filter?.siteId,
    });
  };
  useEffect(() => {
    onClickReset();
  }, [globalSelectedSiteId]);

  const onClickReset = () => {
    setClearDate(true);
    setFilter((prev) => ({
      ...prev,
      startDate: "",
      endDate: "",
      siteId: [],
    }));

    applyFilter((prev) => ({
      ...prev,
      startDate: "",
      endDate: "",
      siteId: [],
    }));
  };

  return (
    <>
      <ScrollBar className="trainingManagementFilter">
        <div className="card" style={{ overflow: "visible", borderRadius: "0px" }}>
          <div className="card-header">Filter</div>
          <div className="searchFilterContainer p-1 pb-2">
            <input
              type="text"
              className="form-control"
              placeholder="Location search..."
              name="searchFilter"
              onChange={onSearchFun}
            />
          </div>
          <Accordion>
            {
              <div
                className={
                  !isActive
                    ? "mb-0 rightFilterAccordion"
                    : "collapsed mb-0 rightFilterAccordion"
                }
              >
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="0"
                  className="rightIncidentCard p-2"
                  style={{ cursor: "pointer" }}
                  onClick={handleToggle}
                >
                  <div className="accordionTitle accordionMainTitle">
                    Head Office <MdKeyboardArrowRight />
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body className="p-2">
                    <Accordion className="pl-2">
                      {filter?.ROsitesData?.map((roData, idx) => (
                        <div
                          className={
                            !roData?.isToggle
                              ? "mb-0 rightFilterAccordion"
                              : "collapsed mb-0 rightFilterAccordion"
                          }
                          key={idx}
                        >
                          <Accordion.Toggle
                            as={Card.Header}
                            eventKey={idx}
                            className="rightIncidentCard p-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => subHandleToggle(idx)}
                          >
                            <div className="accordionTitle">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  value={roData?.name}
                                  id={roData?.id}
                                  name="ROFilter"
                                  onChange={onChange}
                                  checked={filter?.siteId?.includes(roData?.id)}
                                  disabled={!sitesAccess.includes(roData?.id)}
                                />
                                <label
                                  className="form-check-label"
                                  style={{ cursor: "pointer" }}
                                >
                                  {roData?.name} <MdKeyboardArrowRight />
                                </label>
                              </div>
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse eventKey={idx}>
                            <Card.Body className="thirdLabelMenu">
                              {roData?.mineSites?.map((mineData, id) => (
                                <div className="form-check">
                                  <input
                                    value={mineData?.name}
                                    type="checkbox"
                                    className="form-check-input"
                                    id={mineData?.id}
                                    name="MineFilter"
                                    onChange={onChange}
                                    checked={filter?.siteId?.includes(mineData?.id)}
                                    disabled={!sitesAccess.includes(mineData?.id)}
                                  />
                                  <label
                                    className="form-check-label"
                                    style={{ cursor: "pointer" }}
                                  >
                                    {mineData?.name}
                                  </label>
                                </div>
                              ))}
                            </Card.Body>
                          </Accordion.Collapse>
                        </div>
                      ))}
                    </Accordion>
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            }

            <div
              className={
                !isActive2
                  ? "mb-0 rightFilterAccordion"
                  : "collapsed mb-0 rightFilterAccordion"
              }
            >
              <Accordion.Toggle
                as={Card.Header}
                eventKey="1"
                className="rightIncidentCard p-2"
                style={{ cursor: "pointer" }}
                onClick={handleToggle2}
              >
                <div className="accordionTitle accordionMainTitle">
                  Date Range <MdKeyboardArrowRight />
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <Card.Body className="p-2">
                  {/* <DatePicker
                    handleSelect={handleSelect}
                    startDate={filter?.start_date}
                    endDate={filter?.end_date}
                    placeholder="Select Date Range"
                  ></DatePicker> */}

                  <DateTimeFilter getDate={getDate} clear={clearDate} />
                </Card.Body>
              </Accordion.Collapse>
            </div>
          </Accordion>
          <div
            className="filterBtn d-flex justify-content-center"
            style={{ gap: "10px" }}
          >
            <Button variant="primary" onClick={onClickApply}>
              Apply
            </Button>
            <Button variant="danger" onClick={onClickReset}>
              Reset
            </Button>
          </div>
        </div>
      </ScrollBar>
    </>
  );
};

export default RightFilter;
